import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X, Target, Save } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";

export interface ObjetivoProximaVisitaModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const campanhas = [
  "Reduzir Ruptura Média",
  "Aumentar Venda Média",
  "Aumentar Positivação Lançamentos",
  "Reduzir Desconto Médio",
  "Negociar Investimento",
  "Horizontalização",
  "Melhorar Qualidade de Exposição",
  "Ação de Relacionamento",
  "Positivação de Lançamento",
];

const categorias = [
  "DERMATOLOGIA",
  "GENÉRICOS",
  "MIP",
  "PRESCRIÇÃO",
  "INST E CUIDADOS ESPECIAIS",
];

export function ObjetivoProximaVisitaModal({
  open,
  onOpenChange,
}: ObjetivoProximaVisitaModalProps) {
  const [selecoes, setSelecoes] = useState<Record<string, Record<string, boolean>>>({});

  const toggle = (campanha: string, categoria: string) => {
    setSelecoes((prev) => ({
      ...prev,
      [campanha]: {
        ...prev[campanha],
        [categoria]: !prev[campanha]?.[categoria],
      },
    }));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-3xl overflow-hidden rounded-2xl border-none p-0 shadow-2xl [&>button]:hidden">
        <div className="relative overflow-hidden bg-gradient-to-br from-tudo-blue via-tudo-blue to-tudo-blue/80 px-5 py-4 sm:px-6">
          <div className="pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-xl" />
          <div className="pointer-events-none absolute -bottom-12 -left-6 h-28 w-28 rounded-full bg-tudo-green/20 blur-xl" />
          <div className="relative flex items-center justify-between gap-3">
            <div className="flex min-w-0 items-center gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 shadow-inner ring-1 ring-white/20 backdrop-blur-sm">
                <Target className="h-5 w-5 text-white" />
              </div>
              <div className="min-w-0">
                <DialogTitle className="truncate text-left text-lg font-bold tracking-wide text-white">
                  Objetivo próxima Visita
                </DialogTitle>
                <p className="truncate text-xs font-medium text-white/70">
                  Defina metas e próximos passos por categoria
                </p>
              </div>
            </div>
            <button
              onClick={() => onOpenChange(false)}
              className="shrink-0 rounded-lg p-1.5 text-white/80 transition-colors hover:bg-white/10 hover:text-white"
              aria-label="Fechar"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="max-h-[70vh] overflow-y-auto bg-muted/30 p-4 sm:p-5">
          <div className="space-y-3">
            {campanhas.map((campanha) => (
              <div
                key={campanha}
                className="overflow-hidden rounded-xl border border-border bg-card p-4 shadow-sm"
              >
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-tudo-green/10">
                    <Target className="h-4 w-4 text-tudo-green" />
                  </div>
                  <h3 className="text-base font-bold text-foreground">{campanha}</h3>
                </div>
                <div className="grid grid-cols-2 gap-2 border-t border-border pt-3 sm:grid-cols-3 lg:grid-cols-5">
                  {categorias.map((categoria) => {
                    const active = !!selecoes[campanha]?.[categoria];
                    return (
                      <label
                        key={categoria}
                        className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-2 transition-colors lg:flex-col lg:justify-center lg:text-center ${
                          active ? "border-tudo-blue/40 bg-tudo-blue/5" : "border-border bg-muted/30"
                        }`}
                      >
                        <span
                          className={`text-[10px] font-semibold uppercase leading-tight ${
                            active ? "text-tudo-blue" : "text-muted-foreground"
                          }`}
                        >
                          {categoria}
                        </span>
                        <Switch
                          checked={active}
                          onCheckedChange={() => toggle(campanha, categoria)}
                          className="shrink-0 data-[state=checked]:bg-tudo-blue"
                        />
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 flex justify-center">
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-tudo-green to-tudo-green/85 px-8 py-5 text-base font-semibold text-white shadow-md shadow-tudo-green/20 transition-all hover:-translate-y-0.5 hover:shadow-lg focus:ring-2 focus:ring-tudo-green focus:ring-offset-2"
            >
              <Save className="h-4 w-4" />
              Salvar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
